import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { FieldArray, Form, Formik } from "formik";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { clearPlanillaA, clearPlanillaC } from "../../../../redux/actions/rgrl";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import FormikActions from "../../../commons/formik/FormikActions";
import TableTitle from "../../../commons/planillas/TableTitle";
import CustomStepper from "../../../commons/stepper/CustomStepper";
import { StyledRgrl } from "../../../styled/Prevencion";
import { validatePreguntaTable } from "../validation/formValidation";
import PreguntaTableRow from "./PreguntaTableRow";

const columns = [
  { id: "pregunta", label: "Pregunta" },
  { id: "si", label: "Sí" },
  { id: "no", label: "No" },
  { id: "noAplica", label: "N/A" },
  { id: "fechaRegulacion", label: "Fecha Regulación" },
];

const initialValues = {
  idItemFormularioArt: "",
  secuencia: "",
  pregunta: "",
  resultado: "2",
  fechaRegulacion: null,
};

const PreguntaTable = ({
  handleSubmit,
  data,
  contador,
  totalGrupos,
  handleGoBack,
  nombreDecreto,
  preguntasDecreto,
  preguntasDeshabilitadas,
}) => {
  const dispatch = useDispatch();
  const [openConfirmDeshabilitarPlanilla, setConfirmDeshabilitarPlanilla] = useState(null);
  const [openConfirmHabilitarPlanilla, setConfirmHabilitarPlanilla] = useState(null);
  const [planillaAModificar, setPlanillaAModificar] = useState(null);
  const [confirmValues, setConfirmValues] = useState();
  const setModificarEstadoPlanilla = (nombrePlanilla, newValues, habilitar) => {
    if (habilitar) {
      setConfirmHabilitarPlanilla(true);
    } else {
      setConfirmDeshabilitarPlanilla(true);
    }
    setPlanillaAModificar(nombrePlanilla);
    setConfirmValues(newValues);
  }

  const onChangeRadio = (setFieldValue, preguntaIndex, newResultadoValue, newDateValue) => {
    setFieldValue(`itemsFormularioArt.${preguntaIndex}.resultado`,
      newResultadoValue)
    setFieldValue(
      `itemsFormularioArt.${preguntaIndex}.fechaRegulacion`,
      newDateValue
    );
  }
  return (
    <>
      <TableTitle title={data.nombre} />
      <Formik
        initialValues={{
          idGrupoItemFormularioArt: data.idGrupoItemFormularioArt,
          itemsFormularioArt: data.itemsFormularioArt.reduce(
            (itemsFormularioArt, pregunta, index) => {
              itemsFormularioArt[index] = { ...initialValues, ...pregunta };
              return itemsFormularioArt;
            },
            []
          ),
        }}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validationSchema={validatePreguntaTable(nombreDecreto, preguntasDecreto)}
      >
        {({ values, handleChange, setFieldValue, errors }) => (
          <Form>
            <FieldArray name="itemsFormularioArt">
              <StyledRgrl.TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell key={column.id}>{column.label}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.itemsFormularioArt.map((pregunta, preguntaIndex) => (
                      <>
                        <PreguntaTableRow
                          errors={errors}
                          handleChange={handleChange}
                          pregunta={pregunta}
                          preguntaIndex={preguntaIndex}
                          setFieldValue={setFieldValue}
                          values={values}
                          disabled={preguntasDeshabilitadas.includes(pregunta.secuencia)}
                          onChangeRadio={onChangeRadio}
                          nombreDecreto={nombreDecreto}
                          setModificarEstadoPlanilla={setModificarEstadoPlanilla}
                        />
                      </>

                    ))}
                  </TableBody>
                </Table>
                <CustomStepper contador={contador} maxGrupos={totalGrupos} />
                <StyledRgrl.PlanillaTableButtonContainer>
                  <FormikActions
                    submit={
                      contador === totalGrupos - 1
                        ? "Siguiente paso"
                        : "Grupo siguiente"
                    }
                    handleCancel={
                      contador !== 0 ? () => handleGoBack(values) : null
                    }
                    cancel={contador !== 0 ? "Grupo anterior" : null}
                  />
                </StyledRgrl.PlanillaTableButtonContainer>
              </StyledRgrl.TableContainer>
            </FieldArray>
            <ConfirmDialog
              open={openConfirmDeshabilitarPlanilla}
              handleClose={(_, reason) => {
                if (reason && reason === "backdropClick")
                  return;
                setConfirmDeshabilitarPlanilla(false);
              }}
              handleConfirm={() => {
                if (planillaAModificar === "A") {
                  dispatch(clearPlanillaA());
                } else {
                  dispatch(clearPlanillaC())
                }
                onChangeRadio(setFieldValue, ...confirmValues)
                setConfirmDeshabilitarPlanilla(false)
              }}
              title="Pérdida de respuestas seleccionadas"
              warningText={
                <>
                  <b>¡Advertencia!</b> {`Se recuerda que, de cambiar este dato, se eliminará la información cargada en la planilla “${planillaAModificar}” y esta quedará inhabilitada, en función de la trazabilidad de los datos.
                 `}
                </>
              }
              loading={false}

            />

            <ConfirmDialog
              open={openConfirmHabilitarPlanilla}
              handleClose={(_, reason) => {
                if (reason && reason === "backdropClick")
                  return;
                setConfirmHabilitarPlanilla(false);
              }}
              handleConfirm={() => {
                onChangeRadio(setFieldValue, ...confirmValues)
                setConfirmHabilitarPlanilla(false)
              }}
              title={`Acción Requerida: Carga de Planilla “${planillaAModificar}”`}
              warningText={
                <>
                  <b>¡Advertencia!</b> {`Se recuerda que, de cambiar este dato, deberá proceder a la carga de la planilla “${planillaAModificar}”, en función de la trazabilidad de los datos.`}
                </>
              }
              loading={false}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PreguntaTable;
